import store from "../store";
import {parseSubRoleName, RoleCode} from "./role-constant";

export function parseTitle(title) {
  const role = store.state.role;
  const updateTitle =  role === RoleCode.Admin || role === RoleCode.Supervisor || role === RoleCode.TALead ? "HCP" : "Customer"; // "SE/CE" : "Customer";
  if (title === "SE/CE-Activity-Individual-View") return `${updateTitle} Activity - Individual`;
  else if (title === "SE/CE-Activity-Department-View") return `${updateTitle}  Activity - Department`;
  else if (title === "SE/CE-Certification-View") return `${updateTitle} Certification View`;
  else if (title === "User-Activity") {
    let roleName = parseSubRoleName(role);
    roleName = role === null ? "User" : roleName;
    return `${roleName} Activity`;
  } else return title.replace(/-/g, " ");
}

